import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import withComponentName from '../../../decorators/withComponentName';

import Styles from '../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

const RefreshEveryFilter = ({
  dropdown, setValueSelected, refreshFeature,
}) => (
  <>
    {!refreshFeature && (
      <Link className={cx('premium-badge')} to="/pricing">silver</Link>
    )}
    <div className={cx('premium-refresh-values', { disabled: !refreshFeature })}>
      {dropdown.options.slice(0, 3).map((item, index) => (
        <Dropdown.Item
          key={item.name}
          eventKey={index}
          active={dropdown.selected.value === item.value}
          onSelect={() => setValueSelected(item)}
        >
          <span className="dropdown__radio_box" />
          {item.name}
        </Dropdown.Item>
      ))}
    </div>

    {dropdown.options.slice(-2).map((item, index) => (
      <Dropdown.Item
        key={item.name}
        eventKey={index}
        active={dropdown.selected.value === item.value}
        onSelect={() => setValueSelected(item)}
      >
        <span className="dropdown__radio_box" />
        {item.name}
      </Dropdown.Item>
    ))}
  </>
);

export default withComponentName(RefreshEveryFilter);
